var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0769 40.8628C72.3082 40.1278 76.3357 35.6428 76.3469 30.2091C76.3469 24.8541 72.4432 20.4141 67.3244 19.5741",
    stroke: "#00FF47",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9824 53.4392C79.0487 54.1967 82.5849 55.9705 82.5849 59.6267C82.5849 62.143 80.9199 63.778 78.2274 64.8055",
    stroke: "#00FF47",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5738 54.9897C32.5213 54.9897 22.2275 56.816 22.2275 64.1097C22.2275 71.3997 32.4575 73.2785 44.5738 73.2785C56.6263 73.2785 66.9163 71.471 66.9163 64.1735C66.9163 56.876 56.69 54.9897 44.5738 54.9897Z",
    stroke: "#5570F1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5762 44.5796C52.485 44.5796 58.8975 38.1709 58.8975 30.2584C58.8975 22.3496 52.485 15.9371 44.5762 15.9371C36.6675 15.9371 30.255 22.3496 30.255 30.2584C30.225 38.1409 36.5887 44.5534 44.4712 44.5796H44.5762Z",
    stroke: "#5570F1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0679 40.8626C16.8329 40.1276 12.8091 35.6426 12.7979 30.2089C12.7979 24.8539 16.7016 20.4139 21.8204 19.5739",
    stroke: "#FF5C00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1645 53.4392C10.0983 54.1967 6.56201 55.9705 6.56201 59.6267C6.56201 62.143 8.22701 63.778 10.9195 64.8055",
    stroke: "#FF5C00",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersColored);
export default __webpack_public_path__ + "static/media/users-colored.5a026626f1ea2e0be6e3f1ebb0cb8839.svg";
export { ForwardRef as ReactComponent };